import * as React from 'react';
export var Tracker = function (_a) {
    var history = _a.history, location = _a.location, visiting = _a.visiting, visited = _a.visited;
    React.useEffect(function () {
        var url = history.createHref(location);
        var ev = { url: url, location: location };
        visiting(ev);
        return function () { return visited(ev); };
    }, [location.pathname]);
    // tslint:disable-next-line:no-null-keyword
    return null;
};
//# sourceMappingURL=index.js.map